function py_menu_desktop_hover_event(x) {
  if (x.matches) {
      document.querySelectorAll('header .header__inline-menu [id^="Details-"]').forEach((summary) => {
        console.log(summary);
          summary.addEventListener('mouseenter', () => {        
              summary.setAttribute('open', '');
          })
          summary.addEventListener('mouseleave', () => {
              summary.removeAttribute('open');
          })
      });
  }
}

var x = window.matchMedia("(min-width: 990px)");
py_menu_desktop_hover_event(x);
x.addListener(py_menu_desktop_hover_event);